module.exports = __webpack_public_path__ + "static/img/til132.3cf5e01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til132.png
// module id = YA4/
// module chunks = 1